import axios from 'axios';
import gameReviewsData from '../../data/game_reviews.json';

const API_URL = process.env.REACT_APP_API_URL
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True'

const GameReviewService = {
    getAllReviews: async () => {
        try {
            if (STATIC_WEBSITE) {
                return gameReviewsData;
            } else {
                const response = await axios.get(`${API_URL}/gamereviews/`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching games:', error);
            throw error;
        }
    },

    getCount: async () => {
        try {
            if (STATIC_WEBSITE) {
                return gameReviewsData.length;
            } else {
                const response = await axios.get(`${API_URL}/gamereviews/count/`);
                return response.data.count;
            }
        } catch (error) {
            console.error('Error fetching review count:', error);
            throw error;
        }
    }
};

export default GameReviewService;